import { TTokenRedemptionOptionSelectResponse } from '@daymade/api-contracts';
import { useEffect, useState } from 'react';
import HttpStatusCode from 'utils/HttpStatusCode';
import { tokenApiClient } from 'utils/apiClient';

export const useTokenRedemptionOption = (slug?: string) => {
  const [loading, setLoading] = useState(true);
  const [tokenRedemptionOption, setTokenRedemptionOption] =
    useState<TTokenRedemptionOptionSelectResponse | null>(null);
  const [error, setError] = useState<null | string>(null);

  useEffect(() => {
    (async () => {
      if (slug) {
        const resp = await tokenApiClient.public.getTokenRedemptionOptionBySlug(
          {
            params: {
              slug,
            },
          }
        );

        if (resp.status === HttpStatusCode.NOT_FOUND) {
          setError(resp.body.message);
          setLoading(false);
          return;
        }

        setTokenRedemptionOption(resp.body);
      }

      setLoading(false);
    })();
  }, [slug]);

  return { loading, error, tokenRedemptionOption };
};
